// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1_Nc5","right":"styles_right__cceOh"};